import { useEffect } from "react";
import { useBloqueioAdministrativo } from "../../hooks/useBloqueioAdministrativo";
import { defaultResumoLote } from "../../constants/defaultResumoLote";
import { ListarDetalhesLote } from "./containers/lista";
import { ResumoDetalhesLote } from "./containers/resumo";
import { LoadingScreen } from "components/LoadingScreen";

interface IProps {
  setPagina: (pagina: "LOTES" | "DETALHE") => void;
  loteEscolhido: number | null;
}

export function DetalhesLoteBloqueioAdministrativo({
  setPagina,
  loteEscolhido,
}: IProps) {
  const {
    totalRowsDetalhes,
    pageDetalhes,
    limitDetalhes,
    loadingDetalhes,
    setPageDetalhes,
    setLimitDetalhes,
    listarDetalhesLote,
    dadosLote,
    setDadosLote,
    resumoLote,
    setResumoLote,
    buscarResumoLote,
    pesquisaItensLote,
    setPesquisaItenslote,
    reprocessarItensComErro,
  } = useBloqueioAdministrativo();

  function handlePageChange(page: number) {
    setPageDetalhes(page);
  }
  function handleLimitChange(limit: number) {
    setLimitDetalhes(limit);
  }

  useEffect(() => {
    if (loteEscolhido) {
      listarDetalhesLote(loteEscolhido);
      buscarResumoLote(loteEscolhido);
      return;
    }
    setDadosLote([]);
    setResumoLote(defaultResumoLote);
  }, [pageDetalhes, limitDetalhes, pesquisaItensLote]);

  const handleVoltar = () => {
    setDadosLote([]);
    setPagina("LOTES");
    setResumoLote(defaultResumoLote);
  };

  const handleReprocessar = async (idLote: null | number) => {
    await reprocessarItensComErro(idLote);
    if (idLote) {
      listarDetalhesLote(idLote);
      buscarResumoLote(idLote);
    }
  };

  return (
    <>
      <LoadingScreen mostrar={loadingDetalhes} />
      <ResumoDetalhesLote onClickVoltar={handleVoltar} resumo={resumoLote} />
      <ListarDetalhesLote
        idLote={loteEscolhido}
        dados={dadosLote}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRowsDetalhes}
        linhasPorPagina={limitDetalhes}
        pesquisaItensLote={pesquisaItensLote}
        setPesquisaItenslote={setPesquisaItenslote}
        reprocessarItensComErro={handleReprocessar}
      />
    </>
  );
}
